import { useEffect, useState } from 'react';
import { Container, Row, Col } from "reactstrap";
import API_URL from '../../Api'
import no_image from "../../assets/images/no-image.png";
import moment from 'moment';
import { FaLocationDot } from "react-icons/fa6";

const DEFAULT_COUNTDOWN = {
	isEventOver: false,
	isLiveEvent: false,
	days: 0,
	hours: 0,
	minutes: 0,
	seconds: 0
};

export default function Events() {

	const [allEvents, setAllEvents] = useState([]);
	const [eventCountdowns, setEventCountdowns] = useState({});

	useEffect(() => {
		moment.locale('id');
		getAllActivities();
	}, []); // hanya ambil data sekali saat mount

	useEffect(() => {
		if (allEvents.length === 0) return;

		// const testEventDate = moment().add(10, 'seconds');  // set date time for testing
		const interval = setInterval(() => {
			const now = moment();
			const countdowns = {};

			allEvents.forEach(event => {
				const timeEvent = event?.event_lokasi?.[0]?.time_event;
				// Kalau tidak ada tanggal event, pakai default langsung
				if (!timeEvent) {
					countdowns[event.id] = DEFAULT_COUNTDOWN;
					return; // skip ke event berikutnya
				}
				// const eventDate = moment(event?.event_lokasi?.[0]?.time_event || new Date());
				// const eventDate = testEventDate; // get date time for testing
				const eventDate = moment(timeEvent);
				const eventEnd = moment(eventDate).add(1, 'hours');  // <- = end of event (start+1hour)
				const diff = moment.duration(eventDate.diff(now));

				countdowns[event.id] = {
					isEventOver: now.isSameOrAfter(eventEnd),
					isLiveEvent: now.isSameOrAfter(eventDate) && now.isBefore(eventEnd),
					days: diff.asSeconds() > 0 ? Math.floor(diff.asDays()) : 0,
					hours: diff.asSeconds() > 0 ? diff.hours() : 0,
					minutes: diff.asSeconds() > 0 ? diff.minutes() : 0,
					seconds: diff.asSeconds() > 0 ? diff.seconds() : 0
				};
			});

			setEventCountdowns(countdowns);
		}, 1000);

		return () => clearInterval(interval);
	}, [allEvents]);


	const getAllActivities = () => {
		API_URL.baseUrl.get('event/jenis-event-date/2')
			.then(res => res.data)
			.then(data => setAllEvents(data.data));
	};

	function EllipsisText({ text, maxWords }) {
		const truncate = (str) => {
			const words = str.split(" ");
			return words.length > maxWords ? words.slice(0, maxWords).join(" ") + "..." : str;
		};
		return (
			<span title={text} style={{ cursor: "pointer" }}>
				{truncate(text)}
			</span>
		);
	};

	const renderCountdown = (countdown) => {
		if (countdown.days > 0) {
			return (
				<>
					{String(countdown.days).padStart(2, '0')} {countdown.days > 1 ? 'days left' : 'day left'}
				</>
			);
		}
		return (
			<>
				{String(countdown.hours).padStart(2, '0')} :&nbsp;
				{String(countdown.minutes).padStart(2, '0')} :&nbsp;
				{String(countdown.seconds).padStart(2, '0')} left
			</>
		);
	}

	const getEventTypeClass = (category) => {
		return category ? category.toLowerCase() : 'default';
	};

	const getIndonesiaTimezone = (kabupatenName = '') => {
		const name = kabupatenName.toUpperCase();

		const WIB = [
			'MEDAN',
			'BANDUNG',
			'TANGERANG',
			'JAKARTA',
			'YOGYAKARTA',
			'SURABAYA'
		];

		const WITA = [
			'DENPASAR',
			'MAKASSAR'
		];

		if (WIB.some(k => name.includes(k))) {
			return { label: 'WIB', offset: 7 };
		}

		if (WITA.some(k => name.includes(k))) {
			return { label: 'WITA', offset: 8 };
		}

		return { label: 'WIB', offset: 7 };
	};

	const getEventTimeText = (event) => {
		const lokasi = event?.event_lokasi?.[0];
		if (!lokasi?.time_event) return '';

		const kabupatenName = lokasi?.kabupaten?.nama_kabkota || '';
		const { label } = getIndonesiaTimezone(kabupatenName);

		const startTime = moment(lokasi.time_event);
		const endTime = startTime.clone().add(1, 'hours'); // durasi default 1 jam

		return `${startTime.format('HH:mm')} - ${endTime.format('HH:mm')} ${label}`;
	};

	const handleDetailTransition = (event, href) => {
		if (
			event.metaKey ||
			event.ctrlKey ||
			event.shiftKey ||
			event.altKey ||
			event.button !== 0
		) {
			return;
		}

		event.preventDefault();
		const card = event.currentTarget.closest('.event-card');
		card?.classList.add('is-opening');
		document.body.classList.add('page-transition-out');

		window.setTimeout(() => {
			window.location.href = href;
		}, 220);
	};

	return (
		<section className='section events-section' id='events'>
			<Container>
				<div className='events-heading text-center'>
					<span>Info Session</span>
					<h2>Upcoming Event</h2>
					<p>Pilih sesi yang sesuai dan amankan kursimu sebelum kuota penuh.</p>
				</div>
				<Row className='justify-content-center events-grid'>
					{
						allEvents.map((dataJadwal) => {
							const timeEvent = dataJadwal?.event_lokasi?.[0]?.time_event || null;
							const currentCountdown = eventCountdowns[dataJadwal.id] || {
								isEventOver: false,
								days: '--',
								hours: '--',
								minutes: '--',
								seconds: '--'
							};

							const office = dataJadwal?.event_lokasi?.[0]?.alamat || "";

							const locationText = (dataJadwal.category_event === "Offline" || dataJadwal.category_event === "Hybrid")
								? (() => {
									const kotaList = dataJadwal.event_lokasi
										?.map(loc => loc?.kabupaten?.nama_kabkota)
										.filter(Boolean);

									if (!kotaList?.length) return "-";

									const firstCity = kotaList[0];
									const sisaKota = kotaList.length - 1;

									return sisaKota > 0
										? `${firstCity} + ${sisaKota} kota lainnya`
										: firstCity;
								})()
								: "Online";

							const eventDate = moment(dataJadwal?.event_lokasi?.[0]?.time_event || dataJadwal.start_date);
							const timeText = getEventTimeText(dataJadwal);

							const renderAction = () => {
								if (dataJadwal.status_full !== 0) {
									return <button className="event-card-action disabled" type="button">Pendaftaran Penuh</button>;
								}

								if (timeEvent && currentCountdown.isLiveEvent) {
									return (
										<div className='event-card-action-stack'>
											<button className="event-card-action live" type="button">Sedang Berlangsung</button>
											<a
												href={`${process.env.PUBLIC_URL}/detail/${dataJadwal.slug}`}
												className="event-card-action"
												onClick={(event) => handleDetailTransition(event, `${process.env.PUBLIC_URL}/detail/${dataJadwal.slug}`)}
											>
												Daftar Event
											</a>
										</div>
									);
								}

								if (timeEvent && currentCountdown.isEventOver) {
									return <button className="event-card-action disabled" type="button">Event Selesai</button>;
								}

								return (
									<a
										href={`${process.env.PUBLIC_URL}/detail/${dataJadwal.slug}`}
										className="event-card-action"
										onClick={(event) => handleDetailTransition(event, `${process.env.PUBLIC_URL}/detail/${dataJadwal.slug}`)}
									>
										Daftar Event
									</a>
								);
							};

							return (
								<Col key={dataJadwal.id} lg='4' md='6' sm='6' xs='12' className='event-card-col'>
									<article className={`event-card ${currentCountdown.isEventOver ? 'is-over' : ''}`}>
										<div className='event-card-media'>
											<img
												alt='banner-info-session'
												src={dataJadwal.image || no_image}
											/>
											<div className='event-card-date' style={{ backgroundColor: currentCountdown.isEventOver ? 'gray' : '' }}>
												<span>{eventDate.format('ddd')}</span>
												<strong>{eventDate.format('DD')}</strong>
												<span>{eventDate.locale('en').format('MMM').toLocaleUpperCase()}</span>
											</div>
										</div>

										<div className='event-card-body'>
											<div className='event-card-meta'>
												<span className={`event-card-type ${getEventTypeClass(dataJadwal.category_event)}`}>
													{dataJadwal.category_event}
												</span>
												{dataJadwal.category_event?.toLowerCase() !== "online" && (
													<span className='event-card-countdown'>{renderCountdown(currentCountdown)}</span>
												)}
											</div>

											<h3 className='event-card-title'>{dataJadwal.name}</h3>

											<div className="event-card-info">
												<p><FaLocationDot className="icon me-2" />{locationText}</p>

												{timeText && (
													<p>{eventDate.format('DD MMM YYYY')} | {timeText}</p>
												)}

												{dataJadwal?.event_lokasi?.[0]?.place && (
													<p>{dataJadwal.event_lokasi[0].place}</p>
												)}

												{office && <p><EllipsisText text={office} maxWords={8} /></p>}
											</div>

											{renderAction()}
										</div>
									</article>
								</Col>
							)
						})
					}
				</Row>
			</Container>
		</section>
	);
};
